// flow weak

import React, {
    PureComponent,Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils';
  import TimeField from 'react-simple-timefield';
  import { Table } from 'reactstrap';

  class VenueRent extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue_list: [],
        venue:this.props.venue ? this.props.venue : '',
        rent_type:'fixed',
        header:[],

      };
      this.handleChange = this.handleChange.bind(this);
      this.rentUpdated = this.rentUpdated.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.revenuRentUpdated = this.revenuRentUpdated.bind(this);
    }
  
    componentDidMount() {  
      this.getVenueList();

    }
  
    getVenueList(){
        console.log('getVenueList')
        
        // if(val == 1){
        //     var full_operational = "full_operational"
        // }
        // else{
        //     var full_operational = "time_share"
        // }
        const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_rent/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            {venue_list:data.result},()=>{ 
              if(this.state.venue){
                this.getVenueRentDetail(this.state.venue,this.state.rent_type)}});
            })
          .catch(error => error);
        
    }

    getVenueRentDetail(venue,rent_type){
        const url = `${getLocationOrigin()}/venue_rent/get_venue_rent_detail/?venue_id=${venue}&rent_type=${rent_type}`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            {result:data.result,header:data.header});
            })
          .catch(error => error);
    }

    rentUpdated(event) {
      const month = event.target.name.split('_')[1];
      var index = event.target.name.split('_')[0];
      let rent = {...this.state.result};

      rent[month] = event.target.value;
      this.setState({result: rent});
      console.log(event.target.name);
  
  
    }  
  
    revenuRentUpdated(event){
        const month = event.target.name.split('_')[1];
        var index = event.target.name.split('_')[0];
        let rent = {...this.state.result};
  
        rent[month]['rent'] = event.target.value;
        this.setState({result: rent});
        console.log(event.target.name);
    }
    

    handleChange(event) {
        const new_val = event.target;
        const name = new_val.name;
        console.log(new_val.value)
        if(name == 'center_type'){
            this.setState({ center_type:new_val.value})
            if(new_val.value){
                this.getVenueList(new_val.value)
            }
        }

        else if(name == 'venue'){
            this.setState({ venue:new_val.value})
            if(this.state.center_type){
                this.getVenueRentDetail(new_val.value,this.state.rent_type)
            }
        }

        else if(name == 'rent_type'){
            this.setState({ rent_type:new_val.value})
            this.getVenueRentDetail(this.state.venue,new_val.value)
        }
    }

    updateRent() {
        const url = `${getLocationOrigin()}/venue_rent/update_venue_rent/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                    'result':this.state.result,
                                    'venue_id':this.state.venue,
                                    'rent_type':this.state.rent_type});
      console.log('Going to fetch');
      return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {
          alert(response.message);
      })
      .catch(error => {
      console.log(error);
      alert(error.message);
                  });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.updateRent();
      }

  
  
    
  
    render() {
      console.log('render')
      console.log(this.state.venue)
      console.log(this.state.venue_list)
      if(this.state.result){
      console.log(Object.keys(this.state.result))

      console.log(this.state.result.April)
      Object.keys(this.state.result).map((key, index) => (

          console.log(this.state.result[key])
      ))
      }
      return(
        <div style={styles.container}>
         <div className="row col-md-8 table-bordered" style={styles.table} >
            <div style={styles.main_header} className="col-md-12 label_blue_1">
                Venue Rent
            </div>
            
            {this.state.venue_list.length > 0 &&
            <div>
            <div className="row" className="col-md-12" style={{paddingTop:'10px',display:'flex',flexDirection:'row'}}>
                <div style={styles.item_header} className="col-md-6">
                    <lable>Venue</lable>
                </div>
                        <select name="venue"  className="col-md-6" style={styles.item_body} value={this.state.venue}
                            onChange={this.handleChange} disabled={this.props.venue? 'disabled':''}>
                            
                            {
                            this.state.venue_list.map((venue, index) => (
                            <option key={venue.id} value={venue.id}>{venue.name}</option>
                            ))
                            }
                        </select>
                
            </div>


            {this.state.venue &&
            <div className="row" className="col-md-12" style={{marginBottom:'30px',paddingTop:'10px',display:'flex',flexDirection:'row'}}>
                <div style={styles.item_header} className="col-md-6">
                    <lable>Rent Type</lable>
                </div>
                
                    <select name="rent_type"  className="col-md-6" style={styles.item_body} value={this.state.rent_type}
                        onChange={this.handleChange}>
                        <option key={"1"} value={"fixed"}>Fixed</option>
                        <option key={"2"} value={"revenue_share"}>Revenue Share</option>
                    </select>
                
            </div>
            }
            {this.state.result &&
            <div style={styles.item_table}>
           		<Table name="targets_table">
                    <tr>
                        { 	
                            this.state.header.map((key, index) => 
                            <th style={styles.main_header} key={index} value={key}> {key} </th>
                            )
                        }
                    </tr>
                    
                    {this.state.rent_type == "fixed" ?
                     	
                    	Object.keys(this.state.result).map((key, index) => (
                            
                             <tr style={styles.item_body} key={index} value={key}>
                                 <td style={styles.items}>{key}</td>
                                 <td> 
                                     <input name={index + '_' + key} style={styles.input}  index={index} type="number" value={this.state.result[key]} onChange={this.rentUpdated} />  			
                                 </td>		 
                             </tr>   
                            
                        )
                        )
                         :
                        Object.keys(this.state.result).map((key, index) => (
                        
                        <tr style={styles.item_body} key={index} value={key}>
                            <td style={styles.items}>{key}</td>
                            <td> 
                                <input name={index + '_' + key + 'target'} style={styles.input}  index={index} type="number" value={this.state.result[key].achieved_target} />  			
                            </td>		
                            <td> 
                                <input name={index + '_' + key} style={styles.input}  index={index} type="number" value={this.state.result[key].rent} onChange={this.revenuRentUpdated} />  			
                            </td>		 
                        </tr>   
                           
                       )
                       )
                    }
				</Table>
				</div>
            }
            {this.state.result &&
				<div style={styles.button_submit} >
                  <input className="button1" type="submit" value="Update Rent" onClick={this.handleSubmit}/>
                </div>	
            }
            </div>
            }
            </div> 
        </div>
    );
    }
  }
  export default VenueRent;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/venueRent/index.js